import React from 'react';
import styled from 'styled-components';
import { IUploadedImage } from '../../../../../modules/API/Images/models/imageUploadResult';
import OrderImagesBlock from '../../drivers/Components/OrderImagesBlock';

interface Props {
    open: boolean;
    images: IUploadedImage[];
    comment: string;
    isLoading: boolean;
}

/** Фото и комментарий теуды — плавно раскрываются под табами. */
const TeudaImagesPanel: React.FC<Props> = ({ open, images, comment, isLoading }) => (
    // Свёрнутая панель не должна ловить фокус по Tab.
    <Collapse $open={open} inert={!open} aria-hidden={!open}>
        <Inner>
            <Content>
                <OrderImagesBlock
                    images={images}
                    comment={comment}
                    isLoading={isLoading}
                    commentFirst
                    compact
                />
            </Content>
        </Inner>
    </Collapse>
);

export default TeudaImagesPanel;

// grid-template-rows 0fr → 1fr анимирует высоту по содержимому без max-height.
const Collapse = styled.div<{ $open: boolean }>`
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
    transition: grid-template-rows ${({ theme }) => theme.motion.base} ease;
`;

const Inner = styled.div`
    min-height: 0;
    overflow: hidden;
`;

// Отступ от табов внутри сворачиваемой области — схлопывается вместе с ней.
const Content = styled.div`
    padding-top: 0.5rem;
`;
